module.exports = __webpack_public_path__ + "static/maestro-e42ff33abfb7a86ecad4c61363f9f1b6.png";